module.exports = {
  title: 'Sudoku with React Native Reanimated & Skia',
  author: 'Enzo Manuel Mangano',
  date: '2025-04-03',
  slug: 'sudoku',
  tags: ['skia', 'reanimated'],
};
